<template>
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Start body overlay
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
    <div id="body-overlay" class="body-overlay"></div>
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        End body overlay
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->

    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Start Header
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
    <header-section></header-section>
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        End Header
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->

    
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        Start Page Container
        ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
        <section class="page-container">

        <!-- Start Sidebar -->
        <sidebar-section></sidebar-section>
        <!-- End Sidebar -->

        <!-- Start Body Wrapper -->
        <div class="body-wrapper">
            <!-- Start Component Import Mount -->
            <router-view></router-view>
            <!-- End Component Import Mount -->
        </div>
        <!-- End Body Wrapper -->

        <!-- Start StickyBar -->
        <sticky-bar></sticky-bar>
        <!-- End StickyBar -->
    </section>
    <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        End Page Container
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>

<script>
import HeaderSection from '../components/Header.vue';
import SidebarSection from '../components/sidebar.vue';
import StickyBar from '../components/stickyBar.vue';
export default {
    components: { HeaderSection, SidebarSection, StickyBar },
    name: 'templateMaster',
}
</script>

<style>

</style>